<template>
  <FormInput :dati='info'
             :file_key='file_key'
             :formlabel="label"
             :stilestruttura="style"
             :idform="idform"
             :action="action"
             :recaptcha="recaptcha"
             :dateRangeClearable="dateRangeClearable"
             :dateRangeAutoClose="dateRangeAutoClose"
             @dateRangeChanged="handleDateRangeChanged"
             ref="input">
  </FormInput>
  <div v-if="!hideButtons" class="text-right">
    <div v-if="testoaiuto" class="form-actions-note">{{ testoaiuto }}</div>
    <div class="text-right form-actions">
      <a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary form-btn-cancel"
         :href="cancel"><i class="pi pi-times"></i><span class="p-button-label">{{ bottoneannulla }}</span></a>
      <button @click="$refs.input.checkForm(0)" class="p-button p-component p-button-success form-btn-submit">
        <i class="pi pi-send"></i>
        <span class="p-button-label">{{ bottonesalva }}</span>
      </button>
      <template v-if="bottonesalvacontinua !== ''">
        <button @click="validate(1)"
                class="p-button p-component p-button-secondary form-btn-continue">
          <span class="p-button-label">{{ bottonesalvacontinua }}</span>
        </button>
      </template>
    </div>
  </div>

</template>

<script>

import FormInput from './FormInput.vue';

const safeParseJson = (value, fallback) => {
  if (value === undefined || value === null) return fallback;
  if (typeof value !== 'string') return value;
  const normalized = value.replace(/\\'/g, "'");
  try {
    return JSON.parse(normalized);
  } catch (error) {
    console.error('JSON parse error in SingleForm:', error, value);
    return fallback;
  }
};

export default {
  name: "SingleForm",
  components: {
    FormInput,
  },
  props: [
    'dati',
    'file_key',
    'hideButtons',
    'struttura',
    'azione',
    'annulla',
    'stilestruttura',
    'id',
    'recaptcha',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla',
    'testoaiuto',
    'autoSubmitDateRange',
    'dateRangeClearable',
    'autoSubmitTargetDatatableId',
    'dateRangeAutoClose',
  ],
  data() {
    return {
      cancel: this.annulla,
      action: this.azione,
      info: safeParseJson(this.dati, []),
      file_key: this.file_key,
      label: safeParseJson(this.struttura, {}),
      style: this.stilestruttura,
      errors: {},
      imginput: false,
      idform: this.id,
      autoSubmitTimer: null,
      autoSubmitReady: false,
    };
  },
  beforeMount() {
    console.table(this.label)
    if (typeof this.id == "undefined") {
      this.idform = 'maschera';
    } else {
      this.idform = this.id;
    }

  },
  mounted() {
    const thiz = this
    document.addEventListener('formChanged', function (e) {
      if(e.detail.newStruttura){
        thiz.updateStruttura(e.detail.newStruttura)
      }
      
      if (e.detail.newData) {
        thiz.updateData(e.detail.newData)
      }
    });
    this.$nextTick(() => {
      this.autoSubmitReady = true;
    });
  },
  methods: {
    updateStruttura: function (newStruttura) {
      // Aggiorna la label nel componente FormInput direttamente
        this.label = newStruttura;
        this.$refs.input.label = newStruttura;
        // Forza il re-render del componente
        this.$refs.input.$forceUpdate();
    },
    updateData: function (newData) {
      this.$refs["input"].info = newData;
      console.log(this.$refs["input"].info, newData)
    },
    validate: function (tipo) {
      return this.$refs.input.checkForm(tipo)
    },
    handleDateRangeChanged(payload) {
      if (!this.isAutoSubmitDateRangeEnabled()) return;
      if (!this.autoSubmitReady) return;
      const value = payload?.value;
      if (!Array.isArray(value) || value.length !== 2 || !value[0] || !value[1]) return;

      if (this.autoSubmitTimer) {
        clearTimeout(this.autoSubmitTimer);
      }
      this.autoSubmitTimer = setTimeout(() => {
        if (this.autoSubmitTargetDatatableId) {
          const info = this.$refs.input ? this.$refs.input.info : {};
          const routeParams = {
            dateFrom: value[0] instanceof Date ? value[0].toISOString() : value[0],
            dateTo: value[1] instanceof Date ? value[1].toISOString() : value[1],
            pacchetto_ore: info?.pacchetto_ore ?? 0
          };
          document.dispatchEvent(new CustomEvent('datatable-params-changed', {
            detail: {
              datatable_id: this.autoSubmitTargetDatatableId,
              route_params: routeParams
            }
          }));
          return;
        }
        if (this.$refs.input) {
          this.$refs.input.checkForm(0);
        }
      }, 200);
    },
    isAutoSubmitDateRangeEnabled() {
      return this.autoSubmitDateRange === true
        || this.autoSubmitDateRange === 'true'
        || this.autoSubmitDateRange === 1
        || this.autoSubmitDateRange === '1';
    }
  }
}
</script>

<style scoped>

</style>
